import axiosInstance from './axiosInstance';
import { ENDPOINTS } from './endpoints';

export const chipApi = () => axiosInstance.get(ENDPOINTS.CHIP);
export const placeBetApi = (data) => axiosInstance.post(ENDPOINTS.PLACE_BET, data);